export default "__VITE_PUBLIC_ASSET__c7513be4__"